import type { AxiosResponse } from "axios";
import type { ApiResult } from "@/api";

export function apiDataHandle<T>(res: AxiosResponse<ApiResult<T>>) {
  if (Number(res.data.code) === 1 && res.data.success) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.msg));
}
